// ------- money format function -------          
function formatMoney(cents, format) {
  if (typeof cents === "string") cents = cents.replace(".", "");
  let value = "";
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || "${{amount}}";

  const number = (cents / 100).toFixed(2);
  value = number.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");

  return formatString.replace(placeholderRegex, value);
}

// --- custom Add to cart function  ----
let atcErrorTimeoutId = null;
document.addEventListener("click", async function (e) {
  const btn = e.target.closest(".quick-add-size-btn");
  if (!btn) return;

  const variantId = btn.getAttribute("data-variant");
  if (!variantId) return;

  // Identify the Product Card (Desktop) vs. the Popup (Mobile)
  const isMobilePopup = btn.closest("#quickAddMobileContainer");
  const product_card = e.target.closest(".product-card-wrapper");

  const cardContainer = isMobilePopup || product_card;

  const errorWrapper = cardContainer?.querySelector(".product-form__error-message-wrapper");
  const errorMessageEl = cardContainer?.querySelector(".product-form__error-message");
  const loaderEl = cardContainer?.querySelector(".product-card__spinner");

  if (atcErrorTimeoutId) {
    clearTimeout(atcErrorTimeoutId);
  }

  if (loaderEl) loaderEl.classList.remove("hidden");

  try {
    const config = { ...fetchConfig('javascript') };
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    formData.append('form_type', 'product');
    formData.append('sections', "cart-drawer,cart-icon-bubble");
    config.body = formData;

    const response = await fetch(`${routes.cart_add_url}`, config);
    const data = await response.json();

    if (!response.ok || data.status || data.description) {
      const errorMessage = data.description || data.message || "Something went wrong!";
      throw new Error(errorMessage);
    }

    const cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer) {
      if (cartDrawer.classList.contains("is-empty")) {
        cartDrawer.classList.remove("is-empty");
      }
      cartDrawer.renderContents(data);
      cartDrawer.open();
    }
    if (isMobilePopup) {
      document.getElementById("quickAddMobileContainer").classList.remove("is-active");
    }
  } catch (error) {
    console.error("Error adding to cart:", error);
    
    if (errorMessageEl && errorWrapper) {
      errorMessageEl.textContent = error.message;
      errorWrapper.removeAttribute("hidden");
      atcErrorTimeoutId = setTimeout(() => {
        errorWrapper.setAttribute("hidden", "");
        errorMessageEl.textContent = "";
      }, 7000); 
    }
  } finally {
    if (loaderEl) {
      loaderEl.classList.add("hidden");
    }
  }
});

// ------- function to update color product content on swatch click in product card -----------
const CARD_SELECTORS = {
  title: ".card__heading-text",
  color: ".product-color-name",
  priceContainer: ".price__card-product-info",
  priceRegular: ".price__regular",
  priceSale: ".price__sale",
  media: ".card__media .media img",
  sizeContainer: ".quick-add-sizes",
  soldOutBadge: ".badge--sold-out",
  swatches: ".color-swatch-item",
  defaultSizeContainer: ".card__default-option"
};

// Cache parsed product JSON
const swatchProductCache = new Map();

document.addEventListener("click", function (e) {
  const swatch = e.target.closest(CARD_SELECTORS.swatches);
  if (!swatch) return;

  const card = swatch.closest(".card-wrapper");
  if (!card) return;

  // Prevent unnecessary re-render
  if (swatch.classList.contains("active")) return;

  // DATA EXTRACTION & VALIDATION
  const productId = swatch.getAttribute("card-product-id");
  const jsonEl = document.getElementById(`GroupProducts-${productId}`);
  if (!jsonEl) return;

  let products = swatchProductCache.get(productId);

  if (!products) {
    try {
      products = JSON.parse(jsonEl.textContent);
      swatchProductCache.set(productId, products);
    } catch (err) {
      console.error("Invalid product JSON", err);
      return;
    }
  }

  const selectedProduct = products.find(
    p => String(p.id) === String(swatch.dataset.productId)
  );

  if (!selectedProduct) return;

  // CACHE DOM ELEMENTS
  const titleEl = card.querySelector(CARD_SELECTORS.title);
  const colorEl = card.querySelector(CARD_SELECTORS.color);
  const priceContainerEl = card.querySelector(CARD_SELECTORS.priceContainer);
  const priceRegularEl = card.querySelector(CARD_SELECTORS.priceRegular);
  const priceSaleEl = card.querySelector(CARD_SELECTORS.priceSale);
  const sizeContainer = card.querySelector(CARD_SELECTORS.sizeContainer);
  const defaultSizeContainer = card.querySelector(CARD_SELECTORS.defaultSizeContainer);
  const badgesEl = card.querySelectorAll(CARD_SELECTORS.soldOutBadge);
  const images = card.querySelectorAll(CARD_SELECTORS.media);
  const linkEls = card.querySelectorAll("a");

  // UPDATE TEXT CONTENT ONLY IF CHANGED
  // if (titleEl && titleEl.textContent !== selectedProduct.title) {
  //   console.log("titleEl : ", titleEl.textContent, " | selectedProduct.title : ", selectedProduct.title);
  //   titleEl.textContent = selectedProduct.title;
  // }

  if (colorEl && colorEl.textContent !== selectedProduct.color) {
    colorEl.textContent = selectedProduct.color;
  }

  if (priceContainerEl && priceRegularEl && priceSaleEl) {
    const regularPriceItem = priceRegularEl.querySelector('.price-item--regular');
    const salePriceRegularItem = priceSaleEl.querySelector('.price-item--regular');
    const salePriceItem = priceSaleEl.querySelector('.price-item--sale');
    const formattedPrice = formatMoney(selectedProduct.price, window.storeSettings.moneyFormat);

    if (regularPriceItem) regularPriceItem.textContent = formattedPrice;
    const isOnSale = selectedProduct.compare_at_price && selectedProduct.compare_at_price > selectedProduct.price;
    const compAtPrice_status = priceContainerEl.dataset.compare_at_price;
    
    if (isOnSale && compAtPrice_status == "true") {
      const formattedComparePrice = formatMoney(selectedProduct.compare_at_price, window.storeSettings.moneyFormat);      
      if (salePriceRegularItem) salePriceRegularItem.textContent = formattedComparePrice;
      if (salePriceItem) salePriceItem.textContent = formattedPrice;

      priceContainerEl.classList.add('price--on-sale');
    } else {
      if (salePriceRegularItem) salePriceRegularItem.textContent = formattedPrice;
      if (salePriceItem) salePriceItem.textContent = "";

      priceContainerEl.classList.remove('price--on-sale');
    }
  }

  // Check the availability and disabled Add to bag button
  if (defaultSizeContainer) {
    const currentBtn = defaultSizeContainer.querySelector('.quick-add-size-btn');
    const nextContainer = defaultSizeContainer.nextElementSibling;
    const nextBtn = nextContainer ? nextContainer.querySelector('.quick-add-size-btn') : null;

    currentBtn.setAttribute("data-variant", selectedProduct.variants[0].id);
    nextBtn.setAttribute("data-variant", selectedProduct.variants[0].id);

    if (!selectedProduct.available) {
      if (currentBtn) currentBtn.setAttribute('disabled', '');
      if (nextBtn) nextBtn.setAttribute('disabled', '');
    } else {
      if (currentBtn) currentBtn.removeAttribute('disabled');
      if (nextBtn) nextBtn.removeAttribute('disabled');
    }
  }

  // Sold out badge
  badgesEl.forEach(badgeEl => {
    if (badgeEl) {
      badgeEl.style.display = selectedProduct.available ? "none" : "block";
    }
  });

  // Product links
  linkEls.forEach(link => {
    if (link.href !== selectedProduct.url) {
      link.href = selectedProduct.url;
    }
  });

  // Update Size Variant
  if (sizeContainer) {
    const fragment = document.createDocumentFragment();

    selectedProduct.variants.forEach(variant => {
      const btn = document.createElement("button");

      btn.type = "button";
      btn.className = "quick-add-size-btn";
      btn.setAttribute("data-variant", variant.id);
      btn.textContent = variant.variant_title;

      if (!variant.available) {
        btn.disabled = true;
        btn.classList.add("disabled");
      }

      fragment.appendChild(btn);
    });

    sizeContainer.replaceChildren(fragment);
  }

  // IMAGE UPDATES
  if (images.length) {
    if (images[0] && selectedProduct.main_image) {
      images[0].removeAttribute("srcset");

      if (images[0].src !== selectedProduct.main_image) {
        images[0].src = selectedProduct.main_image;
      }
    }

    if (images[1] && selectedProduct.second_image) {
      images[1].removeAttribute("srcset");

      if (images[1].src !== selectedProduct.second_image) {
        images[1].src = selectedProduct.second_image;
      }
    }
  }

  // ACTIVE SWATCH STATE
  const activeSwatch = card.querySelector(
    `${CARD_SELECTORS.swatches}.active`
  );

  if (activeSwatch) {
    activeSwatch.classList.remove("active");
  }

  swatch.classList.add("active");
});

function updateSwatchesNumber() {
  const containers = document.querySelectorAll(".card__swatch-wrapper .color-swatch-list");
  if (containers && containers.length > 0) {
    containers.forEach((container) => {
      const swatches = container.querySelectorAll(".color-swatch-item");
      const moreLink = container.querySelector(".swatch-more-link");
      const counterEl = moreLink.querySelector(".swatch-rest-count");
      const containerWidth = container.offsetWidth;

      let visibleWidth = 0;
      let hiddenCount = 0;
      const moreLinkWidth = 50;

      swatches.forEach((swatch, index) => {
        swatch.classList.remove("is-hidden");
        visibleWidth += swatch.offsetWidth + 8;

        if (visibleWidth > containerWidth - moreLinkWidth) {
          swatch.classList.add("is-hidden");
          hiddenCount++;
        }
      });

      if (hiddenCount > 0) {
        moreLink.style.display = "inline-flex";
        counterEl.innerText = `${hiddenCount}`;
      } else {
        moreLink.style.display = "none";
      }
    });
  }
}

// ---- Run updateSwatchesNumber function on load and resize ----
window.addEventListener("resize", updateSwatchesNumber);
window.addEventListener("DOMContentLoaded", updateSwatchesNumber);

// ----  show quick add popup in mobile ----
document.addEventListener("DOMContentLoaded", function () {
  const mobilePopup = document.getElementById("quickAddMobileContainer");
  const popupContent = mobilePopup.querySelector(".quick-add__options");
  const closeBtn = mobilePopup.querySelector(".quick-add__close");

  document.addEventListener("click", function (event) {
    const iconClick = event.target.closest(".quick-add-icon");
    if (!iconClick) return;

    const productCard = iconClick.closest(".product-card-wrapper");
    const sizesHtml = productCard.querySelector(".quick-add-sizes")?.innerHTML;
    if (!sizesHtml) return;
    popupContent.innerHTML = sizesHtml;
    mobilePopup.classList.add("is-active");
  });

  //  Close Popup
  const closePopup = () => {
    mobilePopup.classList.remove("is-active");
  };

  closeBtn.addEventListener("click", closePopup);

  // Close if clicking outside the wrapper
  mobilePopup.addEventListener("click", (e) => {
    if (e.target === mobilePopup) closePopup();
  });
});

// --------- close description accordion in mobile device -----------
function manageDescAccordionsByScreen() {
  const accordions = document.querySelectorAll(
    ".product-description-wrapper details",
  );
  if (accordions.length === 0) return;

  const isMobile = window.matchMedia("(max-width: 749px)");

  const updateAccordions = (e) => {
    accordions.forEach((accordion) => {
      if (e.matches) {
        accordion.removeAttribute("open");
      } else {
        accordion.setAttribute("open", "");
      }
    });
  };
  // Initial check on page load
  updateAccordions(isMobile);
  // for screen resize/orientation changes
  isMobile.addEventListener("change", updateAccordions);
}
document.addEventListener("DOMContentLoaded", manageDescAccordionsByScreen);

//Menu Drawer tabs
document.addEventListener("DOMContentLoaded", function () {
  // Tab switching
  document.querySelectorAll(".alo-tab").forEach(function (tab) {
    tab.addEventListener("click", function (e) {
      e.stopPropagation();
      const idx = this.dataset.index;
      document.querySelectorAll(".alo-tab").forEach((t) => {
        t.classList.remove("alo-tab--active");
        t.setAttribute("aria-selected", "false");
      });
      document
        .querySelectorAll(".alo-panel")
        .forEach((p) => p.classList.remove("alo-panel--active"));
      // Close any open grandpanels when switching tabs
      document
        .querySelectorAll(".alo-grandpanel--active")
        .forEach((p) => p.classList.remove("alo-grandpanel--active"));
      this.classList.add("alo-tab--active");
      this.setAttribute("aria-selected", "true");
      document
        .querySelector(`.alo-panel[data-index="${idx}"]`)
        .classList.add("alo-panel--active");
    });
  });

  // Open grandchild panel
  document
    .querySelectorAll(".alo-submenu__item--has-children")
    .forEach(function (item) {
      item.addEventListener("click", function (e) {
        e.stopPropagation();
        const panelId = this.dataset.openPanel;
        const panel = document.getElementById(panelId);
        panel.classList.add("alo-grandpanel--active");
        panel.scrollTop = 0;
        let el = item.parentElement;
        while (el) {
          if (el.scrollTop > 0) el.scrollTop = 0;
          el = el.parentElement;
        }
      });
    });

  // Back button — close grandchild panel
  document.querySelectorAll(".alo-back-btn").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.stopPropagation();
      const panelId = this.dataset.closePanel;
      document
        .getElementById(panelId)
        .classList.remove("alo-grandpanel--active");
    });
  });
});
// Megamenu Hover
document.querySelectorAll(".mega-menu").forEach(function (details) {
  details.addEventListener("mouseenter", function () {
    this.setAttribute("open", "");
  });
  details.addEventListener("mouseleave", function () {
    this.removeAttribute("open");
  });
});


//------------- Horizontal Scrollbar slider -----------
const sliderContainers = document.querySelectorAll('.js-slider-container');
if (sliderContainers && sliderContainers.length > 0) {
  sliderContainers.forEach((slider) => {
    // Find the specific track and thumb belonging ONLY to this slider block
    const wrapper = slider.closest('slider-component');
    const thumb = wrapper.querySelector('.js-scroll-thumb');
    const track = thumb.parentElement;

    let isDragging = false;
    let startX, startScrollLeft;

    // Function to update this specific thumb's width and position
    function updateThumb() {
      const contentWidth = slider.scrollWidth;
      const visibleWidth = slider.clientWidth;
      const trackWidth = track.clientWidth;

      // Skip math if content doesn't overflow (no scrollbar needed)
      if (contentWidth <= visibleWidth) {
        track.style.display = 'none';
        return;
      } else {
        track.style.display = 'block';
      }

      // Dynamic width calculation based on parent widths
      const thumbWidth = (visibleWidth / contentWidth) * trackWidth;
      thumb.style.width = `${Math.max(thumbWidth, 20)}px`; // Min 20px

      const maxScroll = contentWidth - visibleWidth;
      const maxThumbMove = trackWidth - thumb.clientWidth;
      
      const scrollRatio = slider.scrollLeft / maxScroll;
      thumb.style.left = `${scrollRatio * maxThumbMove}px`;
    }

    // Drag Events scoped strictly to this instance
    thumb.addEventListener('mousedown', (e) => {
      isDragging = true;
      startX = e.clientX - thumb.offsetLeft;
      startScrollLeft = slider.scrollLeft;
      document.body.style.userSelect = 'none';
    });

    document.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      
      const maxThumbMove = track.clientWidth - thumb.clientWidth;
      let thumbLeft = e.clientX - startX;
      
      thumbLeft = Math.max(0, Math.min(thumbLeft, maxThumbMove));
      
      const scrollRatio = thumbLeft / maxThumbMove;
      const maxScroll = slider.scrollWidth - slider.clientWidth;
      slider.scrollLeft = scrollRatio * maxScroll;
    });

    document.addEventListener('mouseup', () => {
      isDragging = false;
      document.body.style.userSelect = 'auto';
    });

    // Listeners bound strictly to this individual slider
    slider.addEventListener('scroll', updateThumb);
    window.addEventListener('resize', updateThumb);

    // Initialize this specific slider instance
    updateThumb();
  });
}
// --------- refresh cart drawer data when click on back_forward button ---------
async function refreshCartDrawerAndBubble() {
  const cartDrawerElement = document.querySelector('cart-drawer');
  const cartIconBubble = document.getElementById('cart-icon-bubble');
  try {
    const response = await fetch(`${window.Shopify.routes.root}cart?sections=cart-drawer,cart-icon-bubble`);
    const sections = await response.json();

    const parser = new DOMParser();

    // Handle Cart Drawer Update
    if (cartDrawerElement && sections['cart-drawer']) {
      const drawerDoc = parser.parseFromString(sections['cart-drawer'], 'text/html');
      const freshDrawerHTML = drawerDoc.querySelector('cart-drawer');
      if (freshDrawerHTML) {
        cartDrawerElement.replaceWith(freshDrawerHTML);
      }
    }

    // Handle Cart Icon Bubble Update
    if (cartIconBubble && sections['cart-icon-bubble']) {
      const bubbleDoc = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
      const freshBubbleHTML = bubbleDoc.body.innerHTML;
      
      if (freshBubbleHTML.trim() !== "") {
        cartIconBubble.innerHTML = freshBubbleHTML;
      }
    }
  } catch (error) {
    console.error('Error updating cart elements:', error);
  }
}
(function() {
  window.addEventListener('pageshow', function (event) {
    const isBackNavigation = event.persisted || 
      (window.performance && window.performance.getEntriesByType("navigation")[0]?.type === "back_forward");

    if (isBackNavigation) {   
      setTimeout(() => {     
        refreshCartDrawerAndBubble();
      })
    }
  });
})();

// ---------- Update validation message for newsletter form -----------------
function initNewsletterValidation() {
  const formWrapper = document.querySelector('.footer-block__newsletter');
  if (!formWrapper) return;

  const emailInput = formWrapper.querySelector('input[type="email"]');
  const consentCheckbox = document.querySelector('.newsletter-form input[type="checkbox"]');
  const safeEmailPattern = '[A-Za-z0-9._%+\\-]+@[A-Za-z0-9.\\-]+\\.[A-Za-z]{2,}';

  const errorMessages = {
    emailEmpty: window.newsletterStrings.emailEmptyError,
    emailWhitespace: window.newsletterStrings.emailWhitespaceError,
    emailMissingAt: window.newsletterStrings.emailMissingAtError,
    emailIncomplete: window.newsletterStrings.emailIncompleteError,
    emailInvalidFormat: window.newsletterStrings.emailInvalidFormatError,
    checkbox: window.newsletterStrings.checkboxValidationMessage
  };

  // Validation Events to Email Input Field
  if (emailInput) {
    if (!emailInput.hasAttribute('pattern')) {
      emailInput.setAttribute('pattern', safeEmailPattern);
    }

    emailInput.addEventListener('invalid', (event) => {        
      updateValidationMessage(event.target);
    });
    
    emailInput.addEventListener('input', (event) => {
      event.target.setCustomValidity('');
    });
  }

  // Validation Events to Consent Checkbox
  if (consentCheckbox) {
    consentCheckbox.addEventListener('invalid', (event) => {
      event.target.setCustomValidity(errorMessages.checkbox);
    });

    consentCheckbox.addEventListener('change', (event) => {
      event.target.setCustomValidity('');
    });
  }

  emailInput.addEventListener('input', (event) => {
    updateValidationMessage(event.target);
  });

  function updateValidationMessage(input){
    if (input.validity.valueMissing) {
      input.setCustomValidity(errorMessages.emailEmpty);
    } 
    else if (input.validity.typeMismatch) {
      if (input.value.includes('@')) {
        const err_msg = input.value.includes(' ') ? errorMessages.emailWhitespace : errorMessages.emailIncomplete.replace('[value]', input.value);
        input.setCustomValidity(err_msg);
      } else {
        input.setCustomValidity(errorMessages.emailMissingAt.replace('[value]', input.value));
      }
    }
    else if (input.validity.patternMismatch) {
      input.setCustomValidity(errorMessages.emailInvalidFormat)
    }
  }
}
document.addEventListener('DOMContentLoaded', initNewsletterValidation);